import { apiGetLoginBg, userChooseRole } from "@/api/user";
import storage from "@/utils/storage";
import { mapActions } from "vuex";

const defaultBg = require("@/assets/img/login_bg.png");
export const loginBg = {
  data() {
    return {
      bgImg: "",
      gameInfos: null,
    };
  },
  methods: {
    getLoginBg() {
      return new Promise((resolve, reject) => {
        apiGetLoginBg()
          .then((res) => {
            if (res.code === 0 && res.data && res.data.banner_info) {
              this.bgImg = res.data.banner_info.banner || defaultBg;
            } else {
              this.bgImg = defaultBg;
            }
            if (res.code === 0 && res.data && res.data.game_info) {
              this.gameInfos = res.data.game_info || null;
            }
            resolve();
          })
          .catch(() => {
            this.bgImg = defaultBg;
          });
      });
    },
  },
};
import { mapState } from "vuex";
export const changeRole = {
  computed: {
    ...mapState({
      roleList: (state) => state.roleList,
      defaultRoleInfo: (state) => state.defaultRoleInfo,
    }),
    calRoleList() {
      if (this.roleList && this.roleList.length) {
        const arr = this.roleList.map((item) => ({
          text: `${item.role_name}(${item.server_name})`,
          value: item.id,
        }));
        arr.push({ text: "+添加新角色", value: "add" });
        return arr;
      } else {
        return [
          { text: "游客", value: "tourist" },
          { text: "+添加新角色", value: "add" },
        ];
      }
    },
    currentRoleName() {
      let role = this.roleList.find(
        (item) => item.id === this.defaultRoleInfo.id
      );
      return role ? `${role.role_name}(${role.server_name})` : "游客";
    },
  },
  methods: {
    ...mapActions(["checkLogin"]),
    handleChangeRole(value, cb) {
      this.checkLogin()
        .then(() => {
          if (value === "add") {
            this.$router.push({
              name: "BindRoles",
            });
          } else {
            const params = {
              im_role_id: value,
            };
            userChooseRole(params)
              .then((res) => {
                if (res.code === 0) {
                  this.$store.dispatch("getRoleList");
                }
              })
              .finally(() => {
                cb && cb();
              });
          }
        })
        .catch(() => {
          this.$eventBus.$emit("showLogin");
          cb && cb();
        });
    },
  },
};
